var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper-nav"},[_c('div',{class:_vm.navClass,style:(("height:" + _vm.showNavH + "px"))},[_c('span',{staticClass:"hideTipView"},[_vm._v(_vm._s(_vm.getViodModel(_vm.variInfo)))])])])}
var staticRenderFns = []

export { render, staticRenderFns }